// Module
var code = "<div class=modal-header> <h3 translate>loadingService.header</h3> </div> <div class=modal-body name=loadingModal style=text-align:center> <i class=\"fa fa-spinner fa-spin\" style=font-size:xx-large></i> </div>";
// Exports
module.exports = code;